// src/pages/Home.js
import { Box, Link, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SearchBar from "../components/search/SearchBar";
import "../fonts/Milky-Matcha.otf";
import "../styles/home.css"

const Home = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        mb: 15,
        mt: -2
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontFamily: "'Milky-Matcha', sans-serif",
          color: theme.palette.accent.main,
          textAlign: "center",
          mb: 4,
          fontSize: {
            xs: "3.5rem",    // mobile
            sm: "4rem",    // small tablets
            md: "4.5rem",    // desktop
            lg: "5rem",    // large screens
          },
        }}
      >
        stylisher
      </Typography>

      <Typography variant="h6" component="h2" sx={{ mt: -4, mb: 2, color: theme.palette.secondary.main }} gutterBottom>
        neocash trading resource hub
      </Typography>

      <Box sx={{ width: "100%", maxWidth: 500 }}>
        <SearchBar
          fullWidth
          iconColor={theme.palette.accent.main}
        />
      </Box>
      <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
         <Link href="/token-search">Token Search</Link> | New to NC? Check out our <Link href="/guides/beginner-nc-guide">beginner's guide</Link>!
      </Typography>
    </Box>
  );
};

export default Home;
